__turbopack_context__.v({
  "icons_block": "_6-D9CG_icons_block",
  "icons_block__code": "_6-D9CG_icons_block__code",
  "icons_block__description": "_6-D9CG_icons_block__description",
  "icons_block__icon": "_6-D9CG_icons_block__icon",
  "icons_block__row": "_6-D9CG_icons_block__row",
});
